module.exports = __webpack_public_path__ + "img/IMG_7256.eebcb454.webp";